import { render, staticRenderFns } from "./comments-reply-form.vue?vue&type=template&id=5dc1347c"
import script from "./comments-reply-form.vue?vue&type=script&lang=ts"
export * from "./comments-reply-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports